import React from "react";
import { useParams } from "react-router-dom";

const OrderSuccess = () => {
  const { id } = useParams();

  return (
    <div className="order-success" style={{textAlign:"center" , background:"#f7f7f7" , padding:"100px 0px 100px 0px"}}>
      <h1>🎉 Order Placed Successfully!</h1>
      <p>Your Order ID:</p>
      <h3>{id}</h3>
      <p>We will contact you soon!</p>
    </div>
  );
};
 
export default OrderSuccess;
